import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CepPipe } from './cep-pipe';

@NgModule({
  declarations: [CepPipe],
  imports: [
    CommonModule
  ],
  exports: [CepPipe]
})
export class CepPipeModule { }
